/**
 * 文档解析 API 路径
 */
export const DOCUMENT_PARSE_API_PATHS = {
    /** 解析文档 */
    PARSE: '/document-parse/parse',
    /** 解析文档（JSON请求体） */
    PARSE_JSON: '/document-parse/parse-json',
    /** 获取支持的解析类型 */
    PARSE_TYPES: '/document-parse/parse-types',
    /** 获取支持的文件格式 */
    SUPPORTED_FORMATS: '/document-parse/supported-formats',
} as const;

/**
 * 支持的文件格式
 */
export const SUPPORTED_FILE_FORMATS = ['pdf', 'docx'] as const;

/**
 * 支持的解析类型
 */
export const SUPPORTED_PARSE_TYPES = ['text_only', 'image_only', 'both'] as const;

/**
 * 默认文件夹路径
 */
export const DEFAULT_FOLDER_PATH = 'document_parse';

/**
 * 默认文件名前缀
 */
export const DEFAULT_FILE_PREFIX = 'doc';
